"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_dnd_1 = require("react-dnd");
var types_1 = require("chess-fen/types");
exports.usePieceDrop = function (onPieceMove, dropPosition, board) {
    return react_dnd_1.useDrop({
        accept: Object.values(types_1.BoardContent),
        drop: function (pieceDragObject) {
            onPieceMove({
                fromPosition: pieceDragObject.position,
                toPosition: dropPosition,
                board: board
            });
            return undefined;
        },
        collect: function (monitor) { return ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }); },
    });
};
exports.default = exports.usePieceDrop;
